<template>
  <div class="payment-details">
    <div class="top">
      <div class="headline">Payment information</div>
    </div>
    <div class="title">Payment Method</div>
    <div class="psp-item">
      <div class="first">Last PSP reference:</div>
      <div>{{ this.$store.state.subscription.psp_reference }}</div>
    </div>
    <div class="charged-item">
      <div class="first">Last payment:</div>
      <div>{{ this.$store.state.subscription.charged_at }}</div>
    </div>
    <div class="payment-item">
      <div class="first">Current payment type:</div>
      <div class="payment-logo">
        <div
          v-if="this.$store.state.subscription.payment_type == 'card'"
          class="payment-select-item"
        >
          <font-awesome-icon class="icon" icon="credit-card" />
          <span>Credit card</span>
        </div>
        <img
          v-if="this.$store.state.subscription.payment_type != 'card' && this.$store.state.subscription.payment_type != null"
          v-bind:src="
            require('@/assets/payment-methodes/' +
              this.$store.state.subscription.payment_type +
              '.png')
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "payment-details-view",
  data() {
    return {
      paymentType: "paypal",
    };
  },
  props: {},
  components: {},
  computed: {},
  methods: {},
};
</script>

<style scoped>
.payment-details {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.headline {
  font-size: 20px;
  margin-bottom: 15px;
}

.title {
  border-bottom: 1px solid #e7e7e7;
  display: flex;
  width: 100%;
  height: 30px;
  margin-bottom: 20px;
  font-size: 15px;
}
.name {
  display: flex;
  align-items: center;
  margin-right: 20px;
  width: 40%;
}
.payment-logo img {
  height: 100%;
}
.payment-logo {
  height: 50px;
  border: 1px solid #e7e7e7;
  padding: 10px;
  border-radius: 5px;
}
.payment-item {
  display: flex;
  align-items: center;
}
.charged-item {
  display: flex;
  margin-bottom: 15px;
}
.psp-item {
  display: flex;
  margin-bottom: 15px;
}
.first {
  width: 200px;
}
.payment-select-item {
  display: flex;
  align-items: center;
  height: 100%;
}
.payment-select-item svg {
  margin-right: 5px;
}
</style>
